import React from 'react'

function InvoiceList() {
  return (
    <div>InvoiceList</div>
  )
}

export default InvoiceList